import { StyleSheet } from 'aphrodite';
import { error } from '../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 20,
		padding: 20,
	},
	inputContainer: {
		display: 'flex',
		flexGrow: 1,
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		gap: 8,
	},
	customerInfoContainer: {
		display: 'grid',
		gridTemplateColumns: '1fr',
		gap: 16,
		alignItems: 'flex-start',
		justifyContent: 'flex-start',

		'@media (min-width: 722px)': {
			gridTemplateColumns: 'repeat(3, 1fr)',
		},
	},
	addressContainer: {},
	errorMessage: {
		color: error,
		fontSize: 12,
		marginTop: 4,
		marginBottom: 0,
		textAlign: 'left',
	},
	required: {
		color: error,
		fontWeight: 'bold',
	},
});
